module.exports = __webpack_public_path__ + "static/media/hisopados_list.01a79b7f.svg";